import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React from "react";

const UsertypeDropdown = ({ title, value, data, handleChange }) => {
  console.log("value", value);
  return (
    <div>
      <FormControl size="small" fullWidth>
        <InputLabel id="userType-label">Please Select User Type</InputLabel>
        <Select
          id="userType"
          labelId="userType-label"
          label="Please Select User Type"
          value={value}
          onChange={handleChange}
          // disabled={title === "Update" ? true : false}
        >
          {/* <MenuItem disabled>Please Select User Type</MenuItem> */}
          {data &&
            data.map((item, i) => {
              return (
                <MenuItem value={item.roleId} key={i}>
                  <Typography sx={{ textTransform: "capitalize" }}>
                    {item.roleDisplayName}
                  </Typography>
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>
    </div>
  );
};

export default UsertypeDropdown;
